/*
 * @Description:
 * @Author: luckymiaow
 * @Date: 2022-07-11 17:52:24
 * @LastEditors: luckymiaow
 */
import dayjs from 'dayjs';

export function dateTime(value: string | null, pattern = 'YYYY-MM-DD HH:mm:ss'): string | null {
  if (value == null) return value;
  const result = dayjs(value).format(pattern);
  if (result === 'Invalid date') {
    return null;
  }
  return result.replace('00:00:00', '');
}
